// service request
import { View, Text,  Dimensions, TouchableOpacity,} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize, } from "rn-responsive-styles";
import { COLORS } from "../../constant";



const useStyles = CreateResponsiveStyle(
  {
    container: {
      marginLeft: 40,
      minHeight: 650,
    },
    cardWrapper:{ 
      width: 600, 
      flexWrap: 'wrap', 
      flexDirection: 'row',
      paddingLeft:40
    },
    srCard:{
      width:120,
      height:120,
      paddingTop: 17,
      paddingLeft:15,
      paddingRight:5,
      marginRight: 30,
      marginBottom:20
    },
    srCardText:{
      fontSize: 13,
         color: COLORS.white, 
        width: '100%' ,
        paddingTop:10
    },
    headerWidget:{
      minHeight:50,
      paddingLeft:40
    },
    

  },

  {
    [maxSize(DEVICE_SIZES.LG)]: {
     
    },

    [maxSize(DEVICE_SIZES.MD)]: {
      container: {
        height: 800
      },
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      container: {
        marginLeft: 0,
        width: "100%",
      },
      headerWidget:{
        marginTop:-20,
        paddingLeft:0
      },
      srCard:{
        width:90,
        height:90,
        paddingTop: 7,
        paddingLeft:6,
        paddingRight:5,
      },
      srCardText:{
        fontSize:11
      },
    },
    [maxSize(DEVICE_SIZES.XS)]:
    {
      headerWidget:{
        marginTop:-20,
        paddingLeft:0
      },
      srCard:{
        width:80,
        height:80,
        paddingTop: 7,
        paddingLeft:6,
        paddingRight:5,
        marginRight:10
      },
      srCardText:{
        fontSize:10
      },
      container: {
        marginHorizontal: 5,
        height: Dimensions.get('window').height
      },
      cardWrapper:{ 
        paddingLeft:0,
        flexWrap:'wrap',
        width : 300
      }

     
    },
  }
);
export default useStyles;
